export enum EnvMode {
  Development = 'development',
  Test = 'test',
  Production = 'production',
}

export const HEADER_HEIGHT = 56;
export const HEADER_MENU_VERTICAL_OFFSET = HEADER_HEIGHT + 18;
export const EMPTY_PLACEHOLDER = 'N/A';
export const UNSET_FILTER_VALUE = '__unset__';
export const UNSET_FILTER_VALUE_LABEL = 'N/A';
export const DEFAULT_DAYS_BACK = 7;
export const PAGE_SIZE = 50;
export const EXPORT_PAGE_SIZE = 400;
export const GROUP_AUTO_COLLAPSE_THRESHOLD = 5;
export const AI_CHAT_PANEL_WIDTH = 400;
